import PrivateRoute from '@/routes/PrivateRoute';
import { Redirect, Switch } from 'react-router';
import TaxChangeHistoryPage from '@/components/pages/taxNotice/TaxChangeHistoryPage';
import TaxNoticeListPage from '@/components/pages/taxNotice/TaxNoticeListPage';
import TaxNoticeUploadPage from '@/components/pages/taxNotice/TaxNoticeUploadPage';
import TaxNoticeDetailPage from '@/components/pages/taxNotice/TaxNoticeDetailPage';
import { PATH_TAX, PATH_TAX_CHANGE_HISTORY, PATH_TAX_NOTICE_DETAIL, PATH_TAX_NOTICE_LIST, PATH_TAX_NOTICE_UPLOAD } from '@/constants/constant';

const TaxNoticeRoute = () => {
  return (
    <Switch>
      <PrivateRoute b2b path={PATH_TAX_NOTICE_UPLOAD} component={TaxNoticeUploadPage} />
      <PrivateRoute b2b path={PATH_TAX_NOTICE_LIST} component={TaxNoticeListPage} />
      <PrivateRoute b2b path={PATH_TAX_CHANGE_HISTORY} component={TaxChangeHistoryPage} />
      <PrivateRoute b2b exact path={PATH_TAX_NOTICE_DETAIL()} component={TaxNoticeDetailPage} />
      <Redirect path={PATH_TAX} to={PATH_TAX_NOTICE_LIST} />
    </Switch>
  );
};

export default TaxNoticeRoute;
